import { Banner } from 'baseui/banner';
import React, { FC, useEffect } from 'react';
import * as serviceWorker from '../../serviceWorkerRegistration';

const ServiceWorkerWrapper: FC = () => {
    const [showReload, setShowReload] = React.useState(false);
    const [waitingWorker, setWaitingWorker] = React.useState<ServiceWorker | null>(null);

    const onSWUpdate = (registration: ServiceWorkerRegistration) => {
        console.log("PWA Update available 1");
        setShowReload(true);
        setWaitingWorker(registration.waiting);
    };

    useEffect(() => {
        serviceWorker.register({ onUpdate: onSWUpdate });
    }, []);

    const reloadPage = () => {
        console.log("Reload page");
        waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
        setShowReload(false);
        window.location.reload(); //true
        
    };

    return (
        <>
            {showReload && 
                <Banner
                    action={{
                        label: "Reload",
                        onClick: reloadPage,
                    }}
                    title="A new version is available!"
                >
                    Click reload to get the new Version 😁
                </Banner>
            }
        </>
    );
}

export default ServiceWorkerWrapper;